import {
  AvailableLanguage,
  AvailableView,
  IACFOptions,
  IRegion,
  ISaveFormAction,
  ISetHideUrlAction,
  ISetSearchParams,
  IUpdateActiveRegionsAction,
  IUpdateActiveViewAction,
  IUpdateBackdropIndexAction,
  IUpdateCliniquesAction,
  IUpdateCurrentCliniqueAction,
  IUpdateCurrentPersonTypeAction,
  IUpdateCurrentRegionAction,
  IUpdateCurrentStepAction,
  IUpdateCurrentTreatmentAction,
  IUpdateFormIsSubmittingAction,
  IUpdateLocaleAction,
  IUpdateMapActiveMarkerAction,
  IUpdateOptionsAction,
  IUpdateRegionsAction,
  IUpdateTreatmentsAction,
} from 'components/core/types'

export const FETCH_CLINIQUES = 'FETCH_CLINIQUES'
export const fetchCliniques = () => ({ type: FETCH_CLINIQUES })

export const FETCH_OPTIONS = 'FETCH_OPTIONS'
export const fetchOptions = () => ({ type: FETCH_OPTIONS })

export const FETCH_REGIONS = 'FETCH_REGIONS'
export const fetchRegions = () => ({ type: FETCH_REGIONS })

export const FETCH_TREATMENTS = 'FETCH_TREATMENTS'
export const fetchTreatments = () => ({ type: FETCH_TREATMENTS })

export const UPDATE_ACTIVE_REGIONS = 'UPDATE_ACTIVE_REGIONS'
export const updateActiveRegions = (activeRegions: IRegion[]): IUpdateActiveRegionsAction => ({
  type: UPDATE_ACTIVE_REGIONS,
  payload: {
    activeRegions,
  },
})

export const UPDATE_ACTIVE_VIEW = 'UPDATE_ACTIVE_VIEW'
export const updateActiveView = (activeView: AvailableView): IUpdateActiveViewAction => ({
  type: UPDATE_ACTIVE_VIEW,
  payload: {
    activeView,
  },
})

export const UPDATE_LOCALE = 'UPDATE_LOCALE'
export const updateLocale = (locale: AvailableLanguage): IUpdateLocaleAction => ({
  type: UPDATE_LOCALE,
  payload: {
    locale,
  },
})

export const UPDATE_MAP_ACTIVE_MARKER = 'UPDATE_MAP_ACTIVE_MARKER'
export const updateMapActiveMarker = (mapActiveMarker: number): IUpdateMapActiveMarkerAction => ({
  type: UPDATE_MAP_ACTIVE_MARKER,
  payload: {
    mapActiveMarker,
  },
})

export const SAVE_FORM = 'SAVE_FORM'
export const saveForm = (data, setSearchParams: ISetSearchParams): ISaveFormAction => ({
  type: SAVE_FORM,
  payload: {
    data,
    setSearchParams,
  },
})

export const SET_HIDE_URL_STATUS = 'SET_HIDE_URL_STATUS'
export const setHideUrlStatus = (status: boolean): ISetHideUrlAction => ({
  type: SET_HIDE_URL_STATUS,
  payload: {
    status,
  },
})

export const UPDATE_BACKDROP_INDEX = 'UPDATE_BACKDROP_INDEX'
export const updateBackdropIndex = (backdropIndex?: number): IUpdateBackdropIndexAction => ({
  type: UPDATE_BACKDROP_INDEX,
  payload: {
    backdropIndex,
  },
})

export const UPDATE_CLINIQUES = 'UPDATE_CLINIQUES'
export const updateCliniques = (cliniques): IUpdateCliniquesAction => ({
  type: UPDATE_CLINIQUES,
  payload: {
    cliniques,
  },
})

export const UPDATE_CURRENT_CLINIQUE = 'UPDATE_CURRENT_CLINIQUE'
export const updateCurrentClinique = (cliniqueId: number, setSearchParams: ISetSearchParams)
  : IUpdateCurrentCliniqueAction => ({
  type: UPDATE_CURRENT_CLINIQUE,
  payload: {
    cliniqueId,
    setSearchParams,
  },
})

export const UPDATE_CURRENT_PERSON_TYPE = 'UPDATE_CURRENT_PERSON_TYPE'
export const updateCurrentPersonType = (personTypeId: number, setSearchParams: ISetSearchParams)
  : IUpdateCurrentPersonTypeAction => ({
  type: UPDATE_CURRENT_PERSON_TYPE,
  payload: {
    personTypeId,
    setSearchParams,
  },
})

export const UPDATE_CURRENT_REGION = 'UPDATE_CURRENT_REGION'
export const updateCurrentRegion = (regionId: number, setSearchParams: ISetSearchParams)
  : IUpdateCurrentRegionAction => ({
  type: UPDATE_CURRENT_REGION,
  payload: {
    regionId,
    setSearchParams,
  },
})

export const UPDATE_CURRENT_STEP = 'UPDATE_CURRENT_STEP'
export const updateCurrentStep = (step: number, setSearchParams: ISetSearchParams)
  : IUpdateCurrentStepAction => ({
  type: UPDATE_CURRENT_STEP,
  payload: {
    setSearchParams,
    step,
  },
})

export const UPDATE_CURRENT_TREATMENT = 'UPDATE_CURRENT_TREATMENT'
export const updateCurrentTreatment = (treatmentId: number, setSearchParams: ISetSearchParams)
  : IUpdateCurrentTreatmentAction => ({
  type: UPDATE_CURRENT_TREATMENT,
  payload: {
    treatmentId,
    setSearchParams,
  },
})

export const UPDATE_FORM_IS_SUBMITTING = 'UPDATE_FORM_IS_SUBMITTING'
export const updateFormIsSubmitting = (formIsSubmitting: boolean): IUpdateFormIsSubmittingAction => ({
  type: UPDATE_FORM_IS_SUBMITTING,
  payload: {
    formIsSubmitting,
  },
})

export const UPDATE_OPTIONS = 'UPDATE_OPTIONS'
export const updateOptions = (options: IACFOptions): IUpdateOptionsAction => ({
  type: UPDATE_OPTIONS,
  payload: {
    options,
  },
})

export const UPDATE_REGIONS = 'UPDATE_REGIONS'
export const updateRegions = (regions): IUpdateRegionsAction => ({
  type: UPDATE_REGIONS,
  payload: {
    regions,
  },
})

export const UPDATE_TREATMENTS = 'UPDATE_TREATMENTS'
export const updateTreatments = (treatments): IUpdateTreatmentsAction => ({
  type: UPDATE_TREATMENTS,
  payload: {
    treatments,
  },
})
